import React from "react";

const STATS = [
  { num: "100%", label: "Inhouse-Produktion: Konzept, Dreh, Schnitt, Posting", color: "#FFF44F" },
  { num: "<24h", label: "Antwortzeit auf jede Kundenanfrage", color: "#FFFFFF" },
  { num: "1:1", label: "Persönliche Betreuung direkt durch den Inhaber", color: "#2185D0" },
  { num: "0 €", label: "Erstgespräch & ehrliche Ersteinschätzung", color: "#FFF44F" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-[#2E2E2E] text-white py-20 overflow-hidden"
    >
      {/* Decorative circle */}
      <div
        aria-hidden
        className="absolute -right-32 -top-32 w-80 h-80 rounded-full bg-[#2185D0] opacity-25"
      />
      <div
        aria-hidden
        className="absolute -left-20 bottom-0 w-40 h-40 rounded-full border-2 border-[#FFF44F]/30"
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {STATS.map((s, i) => (
            <div key={i} data-testid={`stat-item-${i}`} className="flex flex-col">
              <div className="hh-stat-num text-5xl lg:text-6xl" style={{ color: s.color }}>{s.num}</div>
              <div className="mt-4 font-body text-white/65 text-sm max-w-[220px] leading-relaxed">{s.label}</div>
              <div className="mt-5 w-10 h-[2px]" style={{ background: s.color }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
